import { Typography, styled } from "@mui/material";

const TypographyStyled = styled(Typography)(() => ({
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "14.06px",
  color: "#43434a",
}));

const SmallTextUnstyled = ({ text, className, children }) => (
  <TypographyStyled className={className}>
    {typeof text !== "undefined" ? text : children}
  </TypographyStyled>
);

const SmallText = styled(SmallTextUnstyled)({});

export default SmallText;
